import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[emptyTemplate]'
})
export class EmptyTemplateDirective {
  readonly templateRef = inject(TemplateRef);
}
